import {
  RESET_SALES,
  RESET_SPECIFIC_SALES,
  SET_SALES,
  SET_SPECIFIC_SALES,
  SET_SALES_REPORT,
  SET_UNPAID_POSTED_INVOICES,
  SET_CUSTOMER_STATEMENT_REPORT,
} from "../Types/SalesTypes";

const initialState = {
  allSales: [],
  allSalesReport: [],
  unpaidPostedInvoices: [],
  specificSale: null,
  allCustomerStatementReports:[],
};

const SalesReducer = (state = initialState, action) => {
  if (action.type === SET_SALES) {
    return { ...state, allSales: action.payLoad };
  } else if (action.type === SET_SALES_REPORT) {
    return { ...state, allSalesReport: action.payLoad };
  } else if (action.type === RESET_SALES) {
    return { ...state, allSales: [] };
  } else if (action.type === SET_SPECIFIC_SALES) {
    return { ...state, specificSale: action.payLoad };
  } else if (action.type === SET_UNPAID_POSTED_INVOICES) {
    return { ...state, unpaidPostedInvoices: action.payLoad };
  } else if (action.type === RESET_SPECIFIC_SALES) {
    return { ...state, specificSale: null };
  } else if(action.type === SET_CUSTOMER_STATEMENT_REPORT) {
     return {...state, allCustomerStatementReports: action.payLoad};
  } else {
    return state;
  }
};

export default SalesReducer;
